(function corPdpGallery(){
  function init(){
    var thumbs = document.querySelectorAll('[data-cor-pdp-thumb]');
    var mains  = document.querySelectorAll('[data-cor-pdp-img]');
    if (!thumbs.length || !mains.length) return;
    function ensureLiveRegion(){
      var gallery = document.querySelector('[data-cor-pdp-gallery]');
      if (!gallery) return null;
      var existing = gallery.querySelector('[data-cor-pdp-live]');
      if (existing) return existing;
      var el = document.createElement('span');
      el.setAttribute('data-cor-pdp-live', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      el.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
      gallery.appendChild(el);
      return el;
    }
    var liveRegion = ensureLiveRegion();
    function show(i){
      var activeMain = null;
      mains.forEach(function(m){
        var active = m.getAttribute('data-cor-pdp-img') === String(i);
        m.classList.toggle('is-active', active);
        m.setAttribute('tabindex', active ? '0' : '-1');
        if (active) activeMain = m;
      });
      thumbs.forEach(function(t){
        var active = t.getAttribute('data-cor-pdp-thumb') === String(i);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', String(active));
      });
      if (liveRegion && activeMain) {
        liveRegion.textContent = activeMain.getAttribute('aria-label') || '';
      }
    }
    function applyMainLabels(){
      var isHebrew = document.documentElement.classList.contains('cor-lang-he');
      mains.forEach(function(m){
        var label = isHebrew ? m.getAttribute('data-cor-aria-he') : m.getAttribute('data-cor-aria-en');
        if (label) m.setAttribute('aria-label', label);
      });
    }
    applyMainLabels();
    thumbs.forEach(function(t){ t.setAttribute('aria-pressed', String(t.classList.contains('is-active'))); });
    document.addEventListener('click', function(event){
      if (event.target.closest('[data-cor-lang-choice]')) {
        window.setTimeout(applyMainLabels, 0);
      }
    });
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        show(t.getAttribute('data-cor-pdp-thumb'));
      });
    });
    mains.forEach(function(m){
      m.addEventListener('click', function(){
        var i = parseInt(m.getAttribute('data-cor-pdp-img'), 10);
        var next = (i + 1) % mains.length;
        show(next);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
